import { timeline, catStyle } from "@/mocks/feed";

export default function Timeline() {
  return (
    <section id="timeline" className="w-full scroll-mt-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <p className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-time-line" aria-hidden="true"></i> 今日瓜历
            </p>
            <h2 className="font-display mt-3 text-2xl md:text-4xl text-foreground-950">从早到晚，瓜不缺席</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              以时间线还原今天热点发酵的完整过程。每一个时间点背后，都是一条不断升温的话题曲线。
            </p>

            <div className="mt-6 rounded-2xl border border-background-200/70 bg-accent-100/60 p-5">
              <p className="text-sm font-medium text-accent-900">
                <i className="ri-lightbulb-flash-line mr-1.5" aria-hidden="true"></i>吃瓜小贴士
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                热点通常在晚间达到峰值。关注「今日瓜历」的时间节点，能帮你更清晰地把控全网讨论节奏。
              </p>
            </div>
          </div>

          <ol className="relative lg:col-span-2 space-y-4 before:absolute before:left-[15px] before:top-2 before:bottom-2 before:w-px before:bg-background-200 md:before:left-[19px]">
            {timeline.map((t) => (
              <li key={t.time} className="relative flex gap-4 md:gap-6 pl-0">
                <div className="relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50 ring-4 ring-background-50 md:h-10 md:w-10">
                  <i className="ri-check-double-line" aria-hidden="true"></i>
                </div>
                <div className="min-w-0 flex-1 rounded-2xl border border-background-200/70 bg-background-100 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-display text-base text-primary-700 md:text-lg">{t.time}</span>
                    <span className={`rounded-md px-1.5 py-0.5 text-[11px] font-medium ${catStyle[t.category] || "bg-background-200 text-foreground-700"}`}>{t.category}</span>
                  </div>
                  <h3 className="mt-1.5 text-sm font-medium text-foreground-900 md:text-base">{t.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{t.summary}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}